/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartBarStackedV = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <style>{'.ico-chart-bar-stacked-v_svg__st0{fill:currentcolor}'}</style>
    <path
      className="ico-chart-bar-stacked-v_svg__st0"
      d="M20 20v-5h-2v5h-2v-8h-2v8h-2v-4h-2v4H8v-6H6v6H4V2H2v20h20v-2z"
    />
    <path
      className="ico-chart-bar-stacked-v_svg__st0"
      d="M6 8h2v5H6zm8 0h2v3h-2zm-4-5h2v12h-2zm8 2h2v9h-2z"
    />
  </Icon>
);
export { SvgChartBarStackedV as ChartBarStackedV };
